import { filter } from "lodash";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import config from "../utils/globalConfig";

const useCart = () => {
  const { orderRowDetails, orderDetails, totalReorder, totalSwap, maxSwap } =
    useSelector((state) => state.yodaOrders);
  const { budget } = useSelector((state) => state.yodaBudget);
  const { tab } = useSelector((state) => state.system);

  const [qtyReorder, setQtyReorder] = useState(0);
  const [qtySwap, setQtySwap] = useState(0);
  const [viewedCatalog, setViewedCatalog] = useState([]);

  const reorderExcess = budget?.maxRestock
    ? totalReorder > budget?.maxRestock
    : false;

  const swapExcess = maxSwap < 0;

  useEffect(() => {
    if (orderRowDetails) {
      let f = filter(orderRowDetails, (k, v) => true);
      setQtyReorder(
        f
          .filter((o) => o?.customData?.typeId == config.ORDER_TYPE_REORDER)
          .reduce((prev, curr) => prev + curr.quantity, 0),
      );
      setQtySwap(
        f
          .filter((o) => o?.customData?.typeId == config.ORDER_TYPE_SWAP)
          .reduce((prev, curr) => prev + curr.quantity, 0),
      );

      orderDetailsFiltered();
    }
  }, [tab, orderRowDetails, orderDetails]);

  function orderDetailsFiltered() {
    const orderType =
      tab === 0 ? config.ORDER_TYPE_REORDER : config.ORDER_TYPE_SWAP;
    const returnCatalog = Object.values(orderDetails || {}).reduce(
      (prev, curr) => {
        if (
          curr.orderTypeId === orderType &&
          !prev.find((order) => order.productId === curr.productId)
        )
          prev.push(curr);
        return prev;
      },
      [],
    );
    setViewedCatalog(returnCatalog);
  }

  return {
    totalReorder,
    qtyReorder,
    totalSwap,
    qtySwap,
    reorderExcess,
    swapExcess,
    maxSwap,
    viewedCatalog,
  };
};

export default useCart;
